import React from 'react'
import { Route } from 'react-router-dom'

import FlagInappropriate from './FlagInappropriate'

export default [
  <Route key='flag-message' path='/flag-message' component={FlagInappropriate} />
]



// WEBPACK FOOTER //
// ./src/containers/FlagInappropriate/routes.js